import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
import Modal from './Modal';
import Logo from './Logo';
import ContactForm from './ContactForm';
import Button from './Button';
import closeButton from '../assets/closeButton.svg';
import {getLang} from '../selectors';
import {updateLang} from '../actions';
import {NavDrawer as nds} from '../strings';
import {COLORS} from '../constants';


class NavDrawer extends Component {

  handleClose = () => {
    const {onClose} = this.props;
    onClose();
  }

  handleChangeLang = () => {
    const {lang, updateLang} = this.props;
    let nextLang;
    if (lang === 'en') {
      nextLang = 'es';
    }
    else if (lang === 'es') {
      nextLang = 'en'
    }

    return updateLang({lang: nextLang});
  }

  render() {
    const {
      open,
      lang,
    } = this.props;

    let formattedLang;

    if (lang === 'en') {
      formattedLang = 'Español';
    }
    else if (lang === 'es') {
      formattedLang = 'English';
    }

    return(
      <Modal
        open={open}
        onClose={this.handleClose}
        showCloseButton={false}
        closeTimeoutDuration={400}
        includeBackdrop={false}
        animation="down"
        fullScreen={true}
        bodyStyle={{padding: '0px'}}
        headerStyle={{padding: '0px'}}
      >
        <div style={s.container}>
          <div style={s.header}>
            <div style={s.logoContainer}>
              <Logo isLink={false} useWhite={true} />
            </div>
            <button style={s.closeButtonContainer} onClick={this.handleClose}>
              <img
                style={s.closeButton}
                src={closeButton}
                alt="close"
                className="hover-pointer"
              />
            </button>
          </div>
          <div style={s.content}>
            <div 
              style={s.langContainer}
              >
              <Button
                label={formattedLang}
                color="orange"
                onClick={this.handleChangeLang}
              />
            </div>

            <div style={s.itemsContainer}>

              <Item
                label={nds.home[lang]}
                link="/home"
                onClick={this.handleClose}
              />

              <Item
                label={nds.programs[lang]}
                link="/programs"
                onClick={this.handleClose}
              />

            </div>

            <div style={s.contactContainer}>
              <ContactForm light={true} showTitle={false} />
            </div>

          </div>
        </div>
      </Modal>
    )
  }
}


const s = {
  container: {
    marginTop: '25px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '40px',
  },
  logoContainer: {
   
  },
  closeButtonContainer: {
    marginRight: '20px',
    backgroundColor: 'inherit',
    border: 'none',
  },
  closeButton: {
    width: '30px',
    heigth: '30px',
  },
  content: {
    padding: '20px',
  },
  langContainer: {
    marginBottom: '40px',
    display: 'inline-block',
  },
  itemsContainer: {
    marginBottom: '40px',
  },
  contactContainer: {

  },
}

const Item = (props) => {
  const {label, link, onClick} = props;

  const s = {
    container: {
      marginBottom: '10px',
    },
    label: {
      color: COLORS.lightBlack,
      fontWeight: 'bold',
    },
  }

  return (
    <Link to={link} onClick={onClick}>
    <div style={s.container}>
      <div style={s.label}>
        {label}
      </div>
    </div>
    </Link>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    lang: getLang(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateLang: (params) => dispatch(updateLang(params)),
  }
}


const Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(NavDrawer)

export default withRouter(Connected);



// WEBPACK FOOTER //
// ./src/main/NavDrawer.js